import { createSelector } from 'reselect'

import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'

const getUser = state => state.user

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.VIDEO_LESSON_TYPE,
])

const userShouldSeeVideoLessonsSelector = createSelector(
	[ getUser, featureFlagsSelector ],
	(user, featureFlags) => {
		const isFFReadyForUse = user.featureFlagsHash !== 0
		const shouldSeeVideoLessons = featureFlags[featureFlagsTypes.VIDEO_LESSON_TYPE]
		return !(isFFReadyForUse && !shouldSeeVideoLessons)
	}
)

export default userShouldSeeVideoLessonsSelector
